import { Divider } from '@fluentui/react-components';
import { useParams } from 'react-router-dom';
import { connect } from 'react-redux';
import { Practitioner } from '../../../models/Entities/Practitioners/Practitioner';
import { useEffect, useState } from 'react';
import { AppState } from '../../../redux/reducers';
import { HeaderPersonaComponent } from '../../../commons/component/headers/HeaderPersona/HeaderPersonaComponent';
import PractitionerMedicalInsuranceAssociatedListComponent from '../../../components/Practitioners/PractitionerMedicalInsuranceAssociated/PractitionerMedicalInsuranceAssociatedComponent';
import PractitionerSettingsComponent from '../../../components/Practitioners/PractitionerSettings/PractitionerSettingsComponent';
import PractitionerMedicalServiceAssociatedListComponent from '../../../components/Practitioners/PractitionerMedicalServicesAssociated/PractitionerMedicalServiceAssociatedComponent';
import PractitionerSpecialtyAssociatedListComponent from '../../../components/Practitioners/PractitionerSpecialtyAssociated/PractitionerSpecialtyAssociatedComponent';
import ProfessionalAvailabilityListComponent from '../../../components/ProfessionalAvailability/ProfessionalAvailabilityList/ProfessionalAvailabilityListComponent';
import { PageHeader } from '../../../commons/component/PageHeader/PageHeader';
import SettlementListComponent from '../../../components/Settlements/SettlementList/SettlementList.Component';
import PractitionerContractComponent from '../../../components/Practitioners/PractitionerContract/PractitionerContract.Component';
import { GuideTabs } from '../../../theme/components/GuideTabs';

// Store
import * as PractitionerStore from '../../../redux/middleware/PractitionerMiddleware';
import PractitionerAccountStatementComponent from '../../../components/Practitioners/PractitionerAccountStatement/PractitionerAccountStatement.Component';

////i18Next
import { useTranslation } from 'react-i18next';
import { PractitionerActivityFeedComponent } from '../../../components/Practitioners/PractitionerActivityFeed/PractitionerActivityFeed.Component';
import PractitionerProtocolConsumptionDetailsComponent from '../../../components/Practitioners/PractitionerConsumptions/PractitionerProtocolConsumptionsDetails/PractitionerProtocolConsumptionDetails.Component';

// styles
import './PractitionerDetailsPage.css';

interface IMapsProps {
  Practitioners: Practitioner[] | undefined;
}

interface IDispatchProps {
  GetPractitionerById: typeof PractitionerStore.actionCreators.GetPractitionerById;
}

type IProps = IMapsProps & IDispatchProps;

export const PractitionerDetailsPage = ({
  Practitioners,
  GetPractitionerById
}: IProps) => {
  const { PractitionerId } = useParams();

  useEffect(() => {
    if (PractitionerId) {
      GetPractitionerById(PractitionerId);
    }
  }, [PractitionerId]);

  useEffect(() => {
    if (Practitioners) {
      setPractitioner(
        Practitioners?.find(
          (practitioner: Practitioner) =>
            practitioner.userId === String(PractitionerId)
        )
      );
    }
  }, [Practitioners, PractitionerId]);

  const [practitioner, setPractitioner] = useState<Practitioner | undefined>();

  //useTranslation()
  const [t] = useTranslation();

  return (
    <>
      <PageHeader title={t('practitionerDetailsPage.practitionerDetailsTitle')}/>
      <div className="Content">
        {practitioner && (
          <>
            <div className="Section pdp-section pdp-hero">
              <HeaderPersonaComponent
                PersonaName={practitioner?.fullName}
                secondaryText={practitioner?.speciality}
              />
            </div>
            <div className="Section pdp-section">
              {/* Solapas subrayadas de la guía; sólo se monta la solapa activa (como el Pivot de antes). */}
              <GuideTabs
                ariaLabel={t('practitionerDetailsPage.tabsAriaLabel')}
                data-testid="practitioner-details-tabs"
                tabs={[
                  {
                    key: 'generalInfo',
                    label: t('practitionerDetailsPage.practitionerDetailsItem.generalInfo'),
                    content: <PractitionerActivityFeedComponent practitioner={practitioner.userId} />
                  },
                  {
                    key: 'protocolConsumptions',
                    label: t('practitionerDetailsPage.practitionerDetailsItem.protocolConsumptions'),
                    content: <PractitionerProtocolConsumptionDetailsComponent PractitionerId={practitioner.userId} />
                  },
                  {
                    key: 'providersServes',
                    label: t('practitionerDetailsPage.practitionerDetailsItem.providersServes'),
                    content: (
                      <>
                        <PractitionerSettingsComponent PractitionerId={practitioner.userId} />
                        <Divider className="pdp-divider" />
                        <PractitionerMedicalInsuranceAssociatedListComponent PractitionerId={practitioner.userId} />
                      </>
                    )
                  },
                  {
                    key: 'medicalServices',
                    label: t('practitionerDetailsPage.practitionerDetailsItem.medicalServices'),
                    content: <PractitionerMedicalServiceAssociatedListComponent PractitionerId={practitioner.userId} />
                  },
                  {
                    key: 'specialties',
                    label: t('practitionerDetailsPage.practitionerDetailsItem.specialties'),
                    content: <PractitionerSpecialtyAssociatedListComponent PractitionerId={practitioner.userId} />
                  },
                  {
                    key: 'availability',
                    label: t('practitionerDetailsPage.practitionerDetailsItem.availability'),
                    content: <ProfessionalAvailabilityListComponent PractitionerId={practitioner.userId} />
                  },
                  {
                    key: 'liquidations',
                    label: t('practitionerDetailsPage.practitionerDetailsItem.liquidations'),
                    content: (
                      <div className="VisitasSection">
                        <div>
                          <SettlementListComponent PractitionerId={PractitionerId} />
                        </div>
                        <div>
                          {PractitionerId && <PractitionerContractComponent PractitionerId={PractitionerId}/>}
                        </div>
                      </div>
                    )
                  },
                  {
                    key: 'accountStatement',
                    label: t('practitionerDetailsPage.practitionerDetailsItem.accountStatus'),
                    content: (
                      <PractitionerAccountStatementComponent
                        PractitionerId={practitioner.userId}
                        PractitionerName={practitioner.fullName}
                      />
                    )
                  }
                ]}
              />
            </div>
          </>
        )}
      </div>
    </>
  );
};

const MapStateToProps = (state: AppState, ownProps: any) => {
  return {
    Practitioners: state.Practitioners?.list
  };
};

const MapDispatchToProps = {
  ...PractitionerStore.actionCreators
};

export default connect(
  MapStateToProps,
  MapDispatchToProps
)(PractitionerDetailsPage as any);
